module.exports = __webpack_public_path__ + "img/goldregen-2020-082.987cd008.jpg";